import tw from 'twin.macro';

export const SelectDropdown = tw.select`w-full max-w-full dark:bg-dark mt-1 px-2 py-1 dark:text-white text-base border-gray-300 sm:text-sm rounded-md border shadow-sm`;
